<template>
  <modal name="schedulerPreviewModal" class="custom-modal" :width="'75%'" :height="'auto'"
         :scrollable="true" :pivotX="1.0" :minWidth="900" :minHeight="900" @before-open="beforeOpen" @before-close="beforeClose"
         :clickToClose="true">
    <div class="overlay">
      <div class="icon-back-wrapper" @click="hideModal">
        <div class="icon-back"></div>
      </div>
      <div class="title h2-text">
        Scheduler Preview
      </div>

      <div class="carousel-preview-scheduler">
        <b-button @click="carouselPrevClick" class="carousel-nav-prev carousel-icon">Previous</b-button>
        <b-button @click="carouselNextClick" class="carousel-nav-next carousel-icon">Next</b-button>
        <div class="carousel-preview-item" v-if="currentIndex === 1">
          <div class="h3-text">
            My Information Section
          </div>
          <SchedulerPreviewMyInfoPage
            :hasFluShot="allowBookFluShot"
            :hasSpousal="allowBookForSpouse"
            :spouseLabel="spouseLabel"
          ></SchedulerPreviewMyInfoPage>
        </div>
        <div class="carousel-preview-item" v-if="currentIndex === 2">
          <div class="h3-text">
            Select Location Section
          </div>
          <SchedulerPreviewSelectLocationPage
            :landingTopText="landingTopText"
            :landingBottomText="landingBottomText"
          ></SchedulerPreviewSelectLocationPage>
        </div>
        <div class="carousel-preview-item" v-if="currentIndex === 3">
          <div class="h3-text">
            My Appointment Section
          </div>
          <SchedulerPreviewMyAppointmentPage
            :landingThankYouText="landingThankYouText"
          ></SchedulerPreviewMyAppointmentPage>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import SchedulerPreviewMyInfoPage from './SchedulerPreviewMyInfoPage';
  import SchedulerPreviewMyAppointmentPage from './SchedulerPreviewMyAppointmentPage';
  import SchedulerPreviewSelectLocationPage from './SchedulerPreviewSelectLocationPage';

  export default {
    name: 'schedulerPreviewModal',
    components: {
      SchedulerPreviewMyInfoPage,
      SchedulerPreviewMyAppointmentPage,
      SchedulerPreviewSelectLocationPage
    },
    props: {
    },
    data () {
      return {
        allowBookFluShot: false,
        allowBookForSpouse: false,
        spouseLabel: '',
        landingTopText: '',
        landingBottomText: '',
        landingThankYouText: '',
        currentIndex: 1,
        carouselLength: 3
      }
    },
    methods: {
      beforeOpen (params) {
        this.allowBookFluShot = params.params.allowBookFluShot;
        this.allowBookForSpouse = params.params.allowBookForSpouse;
        this.spouseLabel = params.params.spouseLabel;
        this.landingTopText = params.params.landingTopText;
        this.landingBottomText = params.params.landingBottomText;
        this.landingThankYouText = params.params.landingThankYouText;
      },
      beforeClose () {
      },
      hideModal () {
        this.$modal.hide('schedulerPreviewModal');
      },
      carouselPrevClick () {
        this.currentIndex -= 1;
        if (this.currentIndex < 1) {
          this.currentIndex = this.carouselLength;
        }
      },
      carouselNextClick () {
        this.currentIndex += 1;
        if (this.currentIndex > this.carouselLength) {
          this.currentIndex = 1;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';

  .overlay {
    position: relative;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0);
    z-index: 999;
    cursor: pointer;
    overflow: scroll;
    padding: 0 25px;

    .title {
      padding: 10px 5px;
    }
  }

  .icon-back-wrapper{
    padding-top: 24px;

    .icon-back {
      width: 27px;
      height: 27px;
      color: @grey-3;
      background-color: @grey-3;
      -webkit-mask: url('../../../../static/img/backward-line.svg') no-repeat center;
      mask: url('../../../../static/img/backward-line.svg') no-repeat center;
      background: url('../../../../static/img/backward-line-grey.svg');

      &:hover{
        cursor: pointer;
      }
    }
  }

  .carousel-preview-scheduler {
    padding: 0 40px;

    .carousel-preview-item {
      padding-top: 10px;
    }

    .carousel-nav-prev,
    .carousel-nav-next {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      display: block;
      border: 0;
      cursor: pointer;
      width: 27px;
      height: 27px;
      color: @grey-3;
      background-color: @grey-3;

      &:hover{
        cursor: pointer;
      }
    }

    .carousel-nav-prev {
      left: 5px;
      -webkit-mask: url('../../../../static/img/backward-line.svg') no-repeat center;
      mask: url('../../../../static/img/backward-line.svg') no-repeat center;
      background: url('../../../../static/img/backward-line.svg');
    }

    .carousel-nav-next {
      right: 5px;
      -webkit-mask: url('../../../../static/img/forward-line.svg') no-repeat center;
      mask: url('../../../../static/img/forward-line.svg') no-repeat center;
      background: url('../../../../static/img/forward-line.svg');
    }
  }

</style>



// WEBPACK FOOTER //
// SchedulerPreview.vue?65de3ad8